import moment from 'moment'

import angular from 'angular'
import api from 'components/api'
import clientService from 'common/client.service'

/**
 * PlayerApiService handles player-specific backend communication.
 * It authenticates via clientId (no B2C login required) and provides
 * methods for all player operations scoped to the registered scene.
 */
class PlayerApiService {
  constructor ($log, $q, ApiService, ClientService) {
    'ngInject'

    this._$log = $log
    this._$q = $q
    this._ApiService = ApiService
    this._ClientService = ClientService
    this._authenticated = false
    this._sceneData = null
    this._subscribed = false
    this._sceneSubscribed = false
  }

  /**
   * Authenticate the player via its browser clientId.
   * Returns scene data if successful.
   */
  authenticate (sceneId) {
    const params = { clientId: this._ClientService.id }
    if (sceneId) {
      params.sceneId = sceneId
    }
    return this._ApiService.call('player/authenticate', params).then(data => {
      this._authenticated = true
      this._sceneData = data
      this._$log.info('[PlayerApi] Authenticated for scene', data.sceneId)
      return data
    })
  }

  get isAuthenticated () {
    return this._authenticated
  }

  get sceneData () {
    return this._sceneData
  }

  getScene () {
    return this._ApiService.call('player/getScene')
  }

  getPlayQueue () {
    return this._ApiService.call('player/getPlayQueue')
  }

  subscribe (callback) {
    // Only register the event listener once to prevent stacking duplicates
    // on reconnect. The backend transformer is re-called to re-establish
    // the server-side subscription.
    if (!this._subscribed) {
      this._ApiService.on('playlistitemChanged', callback)
      this._subscribed = true
    }
    return this._ApiService.call('player/subscribe')
  }

  playingStarted (playlistItemId, result) {
    return this._ApiService.call('player/playingStarted', {
      id: playlistItemId,
      timePlayed: moment.utc().format('YYYY-MM-DD HH:mm:ss'),
      result
    })
  }

  playingEnded (playlistItemId, result) {
    return this._ApiService.call('player/playingEnded', {
      id: playlistItemId,
      playbackEnded: moment.utc().format('YYYY-MM-DD HH:mm:ss'),
      result
    })
  }

  heartbeat (version) {
    const data = {}
    if (version) {
      data.version = version
    }
    return this._ApiService.call('player/heartbeat', data)
  }

  subscribeToScene (callback) {
    if (!this._sceneSubscribed) {
      this._ApiService.on('sceneChanged', callback)
      this._sceneSubscribed = true
    }
  }

  setCurrentlyPlaying (playlistItemId) {
    return this._ApiService.call('player/setCurrentlyPlaying', {
      playlistItemId
    })
  }
}

export default angular.module('player-api.service', [
  api,
  clientService
])
  .service('PlayerApiService', PlayerApiService)
  .name
